import { Maybe, UrlParams } from '@sso/common-types';

import { MIGRATION_BRANDS, POYNT, POYNT_EU, UNIREGISTRY } from '../shared/constants';

export function getMigrationBrandName(app: Maybe<string>) {
  if (app == null) {
    return;
  }

  switch (app.toLowerCase()) {
    case POYNT:
      return 'Poynt';
    case POYNT_EU:
      return 'Poynt';
    case UNIREGISTRY:
      return 'Uniregistry';
    default:
      return;
  }
}

export function getMigrationAppFromUrlParams(urlParams: UrlParams): string | undefined {
  return urlParams.migration_app ?? urlParams.app;
}

export function isAppMigrationBrand(app: Maybe<string>) {
  return app != null ? MIGRATION_BRANDS.includes(app.toLowerCase()) : false;
}

export const getIsReseller = (plid: number) => plid !== 1;

export function isResellerConflict(urlParams: UrlParams): boolean {
  if (urlParams.migrate_reseller == null) {
    return false;
  }
  return urlParams.migrate_reseller.toString().toLocaleLowerCase() === 'true';
}
